import React, { useRef, useState } from 'react';
import MainLayout from '../components/Layout/MainLayout.js';

const ContactPage = () => {
    const [status, setStatus] = useState({
        sending: false,
        sent: false,
        error: null
    });

    const nameRef = useRef();
    const emailRef = useRef();
    const messageRef = useRef();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ sending: true, sent: false, error: null });

        const formData = {
            name: nameRef.current.value,
            email: emailRef.current.value,
            message: messageRef.current.value
        };

        try {
            const response = await fetch('/api/sendContactEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error('Beskeden kunne ikke sendes');
            
            setStatus({ sending: false, sent: true, error: null });
            e.target.reset(); // Reset form
        } catch (error) {
            setStatus({ sending: false, sent: false, error: error.message });
        }
    };

    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-lg mx-auto">
                    <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-4">
                        Kontakt os
                    </h1>

                    <div className="prose prose-amber mb-8">
                        <p className="text-gray-600">
                            Har du spørgsmål om vores løsning eller brug for hjælp? 
                            Vi er her for at hjælpe dig med at få den bedste hjemmeside til din håndværkervirksomhed.
                        </p>
                    </div>

                    {status.sent && (
                        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-md">
                            <p className="text-green-800">
                                Tak for din henvendelse! Vi vender tilbage hurtigst muligt.
                            </p>
                        </div>
                    )}

                    {status.error && (
                        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-md">
                            <p className="text-red-800">{status.error}</p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                Navn
                            </label>
                            <input
                                ref={nameRef}
                                type="text"
                                id="name"
                                name="name"
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <input
                                ref={emailRef}
                                type="email"
                                id="email"
                                name="email"
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>

                        <div>
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                                Besked
                            </label>
                            <textarea
                                ref={messageRef}
                                id="message"
                                name="message"
                                required
                                rows="4"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={status.sending}
                            className="w-full flex justify-center py-3 px-4 border border-transparent shadow-sm text-sm font-medium bg-brand-dark text-white rounded-md hover:bg-brand-dark/90 transition-colors duration-200"
                        >
                            {status.sending ? 'Sender...' : 'Send besked'}
                        </button>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
};

export default ContactPage;